import React from 'react';
import FafsaImage from '../../../assets/img/award/fafsa.png';
import SampleImagePage from './sample-image-page';

const styles = {
  card: 'w-[60%] self-stretch px-4 pt-2 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-brand-cyan inline-flex flex-col justify-start items-start',
  title: 'justify-start text-blue text-3xl font-normal font-serif',
  introSection: 'self-stretch',
  introSectionTitle: 'text-xl mb-2',
};

const SampleFafsa = () => {
  return (
    <SampleImagePage
      cardClassName={styles.card}
      titleClassName={styles.title}
      sectionClassName={styles.introSection}
      sectionTitleClassName={styles.introSectionTitle}
      items={[{ title: 'Sample', src: FafsaImage, alt: 'FAFSA Sample', width: '100%' }]}
    />
  );
};

export default SampleFafsa;
